import SessionManager from '../routes/SessionManager';
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

export default class AppConfig {
  static config = {
    google_analytics: {
      measurement_id: {
        prod: 'G-F935M4WR06',
        stage: 'G-N8ZH8ZMT8X',
        qa: 'G-N8ZH8ZMT8X',
        dev: 'G-N8ZH8ZMT8X'
      }
    }
  };

  static loading = {

  };

  static getGoogleAnalyticsId = () => {
    const env = API.ENVIRONMENT;
    return AppConfig.config.google_analytics.measurement_id[env];
  }

  static getConfig = (config_type, config_key) => {
    return new Promise((resolve, reject) => {
      const sessionMgr = new SessionManager();
      let user = sessionMgr.readCookie('user');
      if (!user) {
        reject(new Error('User not authenticated'));
        return;
      }
      var data = {
        user_login: user.user_login,
        user_token: user.user_token,
        source: "D",
        criteria: {
          config_id: config_key,
          from: 0,
          size: 1
        }
      }
      CommonUtils.ajax(
        {
          url: API.COMMON_TABLE_OPERATIONS.COMMON_CONFIG.FETCH,
          type: 'POST',
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(data),
          cache: false
        }
      ).then(
        (res) => {
          if (res.status && res.status.code === 200) {
            if (res.data && res.data.records && res.data.records.length > 0) {
              AppConfig.config[config_key] = res.data.records[0][config_key] || res.data.records[0];
              delete AppConfig.loading[config_key];
              resolve(AppConfig.config[config_key]);
            } else {
              delete AppConfig.loading[config_key];
              reject(new Error(`Config key not found: ${config_key}`));
            }
          } else {
            delete AppConfig.loading[config_key];
            reject(new Error(`API returned status code: ${res.status && res.status.code}`));
          }
        },
        (err) => {
          delete AppConfig.loading[config_key];
          reject(err);
        });
    });
  }

  static getConfigParameter = (config_type, config_key, force = false, timeout = 30000) => {
    return new Promise((resolve, reject) => {
      // Return cached config if available and not forcing refresh
      if (!force && AppConfig.config[config_key]) {
        console.log('Found config: ' + config_key);
        resolve(AppConfig.config[config_key]);
        return;
      }

      // If forcing refresh, clear cached data and loading state
      if (force) {
        console.log('Forcing refresh for config: ' + config_key);
        delete AppConfig.config[config_key];
        delete AppConfig.loading[config_key];
      }

      // If already loading and not forcing, wait for existing request
      if (AppConfig.loading[config_key] && !force) {
        //console.log('Waiting for config: ' + config_key);
        const startTime = Date.now();
        const interval = setInterval(() => {
          if (AppConfig.config[config_key]) {
            clearInterval(interval);
            resolve(AppConfig.config[config_key]);
          } else if (Date.now() - startTime > timeout) {
            clearInterval(interval);
            delete AppConfig.loading[config_key];
            reject(new Error(`Config fetch timeout: ${config_key}`));
          }
        }, 100);
        return;
      }

      // Fetch new config
      console.log('Fetching config: ' + config_key);
      AppConfig.loading[config_key] = true;
      AppConfig.getConfig(config_type, config_key)
        .then((configValue) => {
          resolve(configValue);
        })
        .catch((err) => {
          delete AppConfig.loading[config_key];
          reject(err);
        });
    });
  }
}